export default "__VITE_ASSET__5CJ3ejqT__"